// UTC-safe date utilities
// Normalize any date-like input to a UTC date with time set to 00:00:00
export function normalizeToUTC(date) {
  const d = new Date(date);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
}

// True if the target date is strictly before today (UTC)
export function isPastDate(date) {
  const todayUTC = normalizeToUTC(new Date());
  const targetUTC = normalizeToUTC(date);
  return targetUTC < todayUTC;
}

// True if the target date is today or in the future (UTC)
export function isTodayOrFuture(date) {
  const todayUTC = normalizeToUTC(new Date());
  const targetUTC = normalizeToUTC(date);
  return targetUTC >= todayUTC;
}
